const UserRoles = {
    manager: 'manager',
    participant: 'participant',
    admin: 'primary_administrator',
    sysAdmin: 'system_administrator',
} as const;

export type UserRole =
    | typeof UserRoles.manager
    | typeof UserRoles.participant
    | typeof UserRoles.admin
    | typeof UserRoles.sysAdmin;

export default UserRoles;
